<template>
  <div class="pageContent">
    <Loading class="loading" v-if="this.waiting" />

    <div v-else>
      <div v-if="showGraph" :class="[{ graphSection: true }]">
        <modalGraph
          :key="nodeSelected.keySelect"
          :nodeSelected="nodeSelected"
          :onCloseModal="onCloseModal"
        ></modalGraph>
      </div>
      <div
        :class="[
          {
            dashSectionWithModal: dashSectionWithModal,
            dashSectionWithoutModal: dashSectionWithoutModal,
          },
        ]"
      >
        <div
          :class="[
            {
              headerDash: true,
              headerDashPositionWithoutModal: headerDashPositionWithoutModal,
              headerDashPositionWithModal: headerDashPositionWithModal,
            },
          ]"
          id="hd"
        >
          <div>{{ $t('nome') }}</div>
          <div >{{ $t('real') }}</div>
          <div >{{ $t('previsto') }}</div>
          <div >{{ $t('desvio') }}</div>
          <div >{{ $t('status') }}</div>
        </div>

        <div class="filter-box" >
          <label for="filter-tree">{{ $t('filtro') }}</label>
          <input
            type="text"
            id="filter-tree"
            class="ml-1 input"
            v-model="treeFilter"
          />
          <img
            id="imprimir-tree-id"
            v-print="printObj"
            class="ml-2 printer-button"
            src="../../assets/printer.png"
            :title="$t('imprimir-arvore')"
            :alt="$t('imprimir')"
          />
          <img
            id="reload-tree-id"
            class="ml-2 printer-button"
            src="../../assets/atualizar.png"
            :alt="$t('atualizar-arvore')"
            :title="$t('atualizar-arvore-0')"
            @click="loadTreeIndicator"
          />
          <b-icon-chevron-expand 
            :title="$t('visualizar-tudo')"
            class="expand-tree"
            @click="expandAll"
          ></b-icon-chevron-expand>
        </div>
        
        <tree
          id="printMe"
          ref="tree"
          :data="items"
          @node:dblclick="onNodeSelect"
          :options="treeOptions"
          :filter="treeFilter"
        >
        <span id="tree-text" class="tree-text grid" slot-scope="{ node }">
            <template v-if="!node.hasChildren()">
              <template v-if="node.data.key.split('')[0] == 'K'">
                <span class="tree-text">
                  <div class="col1" :title="node.data.indicatorName">
                    {{ node.data.indicatorName }}
                    <span v-if="node.data.timestamp != '1900-01-01 00:00:00'"
                      >- {{ node.data.timestamp | dateBRTimestamp }}</span
                    >
                  </div>
                  <div class="col2">{{ ParseNumber(node.data.value) }}</div>
                  <div class="col3">{{ ParseNumber(node.data.target) }}</div>
                  <div class="col4">{{ ParseNumber(node.data.deviation) }}</div>
                </span>
                <div class="col5">
                  <SemaforoVerde
                    v-if="node.data.alert != true && node.data.showData == 1"
                  />
                  <SemaforoVermelho
                    v-if="node.data.alert == true && node.data.showData == 1"
                  />
                </div>
              </template>
              <template v-if="node.data.key.split('')[0] == 'O'">
                <span class="col1 font-italic" :title="node.data.description"
                  >{{ node.data.baseDate != null ? node.data.baseDate : node.data.creationDate | dateBR }} -
                  <span :v-html="deadlineLabel(node.data.deadlineInDays)"></span>
                  - {{ node.data.description }}</span
                >
                <span class="col5" v-if="node.data.deadlineInDays >= 0">
                  <SemaforoVerde />
                </span>
                <span class="col5" v-else>
                  <SemaforoVermelho/>
                </span>
              </template>
            </template>

            <template v-else>
              <template v-if="node.data.key.split('')[0] == 'K'">
                <span class="tree-text rootStyle" v-if="node.data.root == 1">
                  <template
                    v-if="
                      node.data.key == 'KG0110000000' ||
                        node.data.key == 'KG00000000'
                    "
                  >
                    <div class="col1">
                      <b>
                        {{ node.data.description }}
                        {{ node.data.indicatorName }}
                      </b>
                    </div>
                    <div class="col2 root-header"><b>{{ $t('real') }}</b></div>
                    <div class="col3 root-header"><b>{{ $t('previsto') }}</b></div>
                    <div class="col4 root-header"><b>{{ $t('desvio-0') }}</b></div>
                    <div class="col5 root-header"><b>{{ $t('status') }}</b></div>
                  </template>
                  <template v-else>
                    <div id="col-indicator-name" class="col1" :title="node.data.indicatorName">
                      <b>
                        {{ node.data.indicatorName }}
                        <span
                          v-if="node.data.timestamp != '1900-01-01 00:00:00'"
                        >
                          -
                          {{ node.data.timestamp | dateBRTimestamp }}
                        </span>
                      </b>
                    </div>
                    <div class="col2">
                      <b v-if="node.data.showData == 1">{{
                        ParseNumber(node.data.value)
                      }}</b>
                    </div>
                    <div id="col-data-target" class="col3">
                      <b v-if="node.data.showData == 1">{{
                        ParseNumber(node.data.target)
                      }}</b>
                    </div>
                    <div class="col4">
                      <b v-if="node.data.showData == 1">{{
                        ParseNumber(node.data.deviation)
                      }}</b>
                    </div>
                  </template>
                </span>
                <span class="tree-text" v-if="node.data.root == 0">
                  <div class="col1">
                    {{ node.data.indicatorName }}
                    <span v-if="node.data.timestamp != '1900-01-01 00:00:00'"
                      >- {{ node.data.timestamp | dateBR }}</span
                    >
                  </div>
                  <div class="col2">{{ ParseNumber(node.data.value) }}</div>
                  <div class="col3">{{ ParseNumber(node.data.target) }}</div>
                  <div class="col4">{{ ParseNumber(node.data.deviation) }}</div>
                </span>
                <div class="col5">
                  <SemaforoVerde
                    v-if="node.data.alert != true && node.data.showData == 1"
                  />
                  <SemaforoVermelho
                    v-if="node.data.alert == true && node.data.showData == 1"
                  />
                </div>
              </template>
              <template v-else>
                <span class="col1">
                  <b>{{ node.data.description }}</b>
                </span>
              </template>
            </template>
          </span>
        </tree> 
      </div>

      <b-modal id="UntratedOccurrences" size="xl" hide-footer :no-close-on-backdrop="true">
        <div slot="modal-title" class="d-flex align-items-center">
          <img
            id="occurrence-icon"
            src="../../assets/circular138.png"
            alt="salvar_ocorrencia"
          />
          {{ $t('editor-de-ocorrencia') }} </div>
          <ManageAllOccurrences
            :occurrenceInfo="nodeSelected.occurrenceSelected"
            :reloadOccFunct="loadTreeIndicator"
            :indicatorInfo="null"
          />


        <!-- <OccurrenceDetails
          :nodeSelected="nodeSelected.occurrenceSelected"
          :loadTree="loadTreeIndicator"
          :lastIndicatorNodeSelected="lastIndicatorNodeSelected"
          @getLastIndicatorNodeSelected="getLastIndicatorNodeSelected($event)"
        ></OccurrenceDetails> -->
      </b-modal>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import PageTitle from "../template/PageTitle";
// eslint-disable-next-line no-unused-vars
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import { urlMainAPI, showError } from "@/global";
// import {mapState} from "vuex";
import Tree from "liquor-tree";
import Loading from "@/components/template/Loading.vue";
import modalGraph from "@/components/dashboard/modal/modalGraph.vue";
import SemaforoVerde from "@/components/utils/SemaforoVerde.vue";
import SemaforoVermelho from "@/components/utils/SemaforoVermelho.vue";
import { FiltersMixin } from "../mixins/filtersMixin";
import { defaultSuccess } from '../../global';
import ManageAllOccurrences from "../manageAllOccurrences/ManageAllOccurrences.vue";

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: {
    Tree,
    Loading,
    modalGraph,
    SemaforoVerde,
    SemaforoVermelho,
    ManageAllOccurrences
  },

  mixins: [FiltersMixin],

  // components: { Tree, Loading },
  // computed: mapState(["showWait"]),
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.calcType = to.params.type;
      this.treeFilter = ""
      this.loadTreeIndicator();
    },
  },
  filters: {
    dateBR(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      let info = dateBr.split(" ");
      dateBr = info[0];
      if (dateBr == "Invalid") {
        return "erro";
      }

      return dateBr;
    },
    dateBRTimestamp(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      let info = dateBr.split(" ");
      dateBr = info[0];
      let time = info[1].substring(0, 5);
      if (dateBr == "Invalid") {
        return "erro";
      } else {
        return (dateBr = dateBr + " " + time);
      }
    },

    validateDivision(num) {
      if (isNaN(num)) {
        return "0,00";
      }
      if (num == Infinity) {
        return "0,00";
      }
      if (num == "-9999")
        return num;
    },

    percent(num) {
      num = (parseFloat(num) * 100).toFixed(4);
      return num;
    },
    numberFormat(num) {
      try {
        if (num == "-9999" || num == "-9999") {
          return "0,00";
        }
        if (num.includes(",")) {
          num = num.replace(",", ".");
        }
        if (!isNaN(parseFloat(num))) {
          var numParsed = parseFloat(num);
          if (
            (numParsed > 0 && numParsed < 1) ||
            (numParsed < 0 && numParsed > -1)
          ) {
            numParsed = numParsed.toFixed(4);
          } else {
            numParsed = numParsed.toFixed(2);
          }
          numParsed = numParsed.replace(".", ",").split(",");
          let v1 = numParsed[0];
          let v2 = numParsed[1];
          v1 = v1.split("").reverse();
          let i = 0;
          var stop = 0;
          if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
            i = 1;
            stop = Math.trunc(v1.length / 3);
          }
          if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
            i = 1;
            stop = Math.trunc(v1.length / 3) - 1;
          }
          var pos = 3;
          if (i >= 1) {
            for (i; i <= stop; i++) {
              v1.splice(pos, 0, ".");
              pos = pos + 4;
            }
          }
          numParsed = v1.reverse().join("") + "," + v2;
          if (numParsed.includes("-.")) {
            numParsed = numParsed.replace("-.", "-");
          }
          return numParsed;
        }
        return num;
      } catch (error) {
        return num;
      }
    },
  },
  data: () => ({
    calcType: "",
    items: null,
    treeFilter: "",
    printObj: {
      id: "printMe",
      popTitle: "Árvore de Indicadores",
      extraHead: `
      <div style="text-align: center">
        <h3>ÁRVORE DE INDICADORES</h3>
      </div>
      `,
    },
    treeOptions: {
      filter: {
        emptyText: "Sem resultados!",
        showChildren: true,
        plainList: false,
        matcher(query, node) {
          return (
            new RegExp(query, "i").test(node.data.indicatorName) ||
            new RegExp(query, "i").test(node.data.description)
          );
        }
      },
    },
    waiting: false,
    showGraph: false,
    showOccurrence: null,
    headerDashPositionWithModal: false,
    headerDashPositionWithoutModal: true,
    dashSectionWithoutModal: true,
    dashSectionWithModal: false,
    lastIndicatorNodeSelected: {
      keySelect: 0,
      indicatorNameSelect: "",
      indicatorCalcType: "",
    },
    nodeSelected: {
      keySelect: 0,
      indicatorNameSelect: "",
      indicatorCalcType: "",
      occurrenceSelected: undefined,
      collapsedTree: false,
    },
  }),
  methods: {
    showModal() {
      this.headerDashPositionWithModal = true;
      this.headerDashPositionWithoutModal = false;
      this.dashSectionWithoutModal = false;
      this.dashSectionWithModal = true;
    },

    expandAll(){
      this.$refs.tree.findAll(el => el.expand())
    },

    async onNodeSelect(node) {
      const selection = this.$refs.tree.find({ id: node.id });
      selection.expand();

      const flag = node.data.key.charAt(0).toUpperCase();

      if (flag === 'K') {
        this.showOccurrence = false;
        if (this.showGraph) {
          this.showGraph = false;
          await this.$nextTick();
        }

        this.nodeSelected = {
          keySelect: node.data.key,
          indicatorCalcType: node.data.calcType,
          indicatorNameSelect: node.data.indicatorName,
          occurrenceSelected: undefined,
          collapsedTree: false,
        };
        this.lastIndicatorNodeSelected = { ...this.nodeSelected };

        this.showGraph = true;
        this.showModal();

      } else if (flag === 'O' && node.data.root === 0) {
        this.nodeSelected.keySelect = node.data.key;
        this.nodeSelected.occurrenceSelected = node.data;
        this.$bvModal.show('UntratedOccurrences');
      }
    },

    onCloseModal() {
      this.showGraph = false;
      this.showOccurrence = false;
      this.headerDashPositionWithModal = false;
      this.headerDashPositionWithoutModal = true;
      this.dashSectionWithoutModal = true;
      this.dashSectionWithModal = false;
    },

    async loadTreeIndicator() {
      console.log("ATT")
      const url = `${urlMainAPI}/getindicatortree/${this.calcType}`
      await axios
        .get(url)
        .then((res) => {
          if(res.status == 200){
            this.items = res.data.data;
  
            if(this.$refs.tree ){
              this.$refs.tree.tree.setModel(this.items)
              let aux = this.treeFilter;
              this.treeFilter = "";
              setTimeout(() => { this.treeFilter = aux; }, 5);
              defaultSuccess(this.$t('arvore-atualizada'))
            }
          }
        })
        .catch(console.error);
    },

    deadlineLabel(deadlineInDays) {
      if (deadlineInDays < 0) {
        return "Atraso em dias: " + Math.abs(deadlineInDays);
      }
      return "Prazo em dias: " + deadlineInDays;
    },
    getLastIndicatorNodeSelected(node){
      this.nodeSelected.keySelect = node.keySelect;
      this.nodeSelected.indicatorCalcType = node.indicatorCalcType;
      this.nodeSelected.indicatorNameSelect = node.indicatorName; 
    }
  },

  async created() {
    this.calcType = this.$route.params.type, 
    this.waiting = true
    await this.loadTreeIndicator();
    this.waiting = false
  },
};
</script>

<style scoped>
@media print {
  @page {
    size: A3 landscape;
  }
}

#hd {
  border-top-right-radius:  6px;
  border-top-left-radius:  6px;
} 

 #filter-tree{
  margin-top: 1.4rem;
  margin-bottom: 0.2rem;
}

.printer-button {
  height: 30px;
  width: 30px;
  cursor: pointer;
}

#occurrence-icon {
  width: 33px;
  height: 33px;
  margin-right: 10px;
}

.expand-tree{
  position: relative;
  top: 6px;
  left: 2px;
  font-size: 34px;
  color: #ff5f00;
  cursor: pointer;
}

/* .col1Header {
  max-width: 564px;
  text-align: center;
}

.col2Header {
  position: absolute;
  left: 600px;
  padding-left: 0px;
  min-width: 200px;
  text-align: center;
}

.col3Header {
  position: absolute;
  left: 800px;
  padding-left: 0px;
  min-width: 200px;
  text-align: center;
}

.col4Header {
  position: absolute;
  left: 1000px;
  padding-left: 0px;
  min-width: 200px;
  text-align: center;
}

.col5Header {
  position: absolute;
  left: 1200px;
  padding-left: 0px;
  min-width: 100px;
  text-align: center;
} */

.tree-text {
  display: grid;
  font-family: Arial;
  font-size: 14pt;
  width: 100%;
}

.rootStyle {
  font-weight: 500;
}

.loading {
  position: absolute;
  top: Calc(50% - 128px);
  left: Calc(50% - 128px);
}

.col1 {
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(60% - 50px);
  min-width: 89.09px;
}

.col2 {
  position: absolute;  
  left: calc(100% - 39.1%);
  width: calc(10% - 30px);
  min-width: 89.09px;
  text-align: center;
}

.col3 {
  position: absolute;
  left: calc(100% - 29%);
  width: calc(10% - 30px);
  min-width: 89.09px;
  text-align: center;
 
}

.col4 {
  position: absolute;
  left: calc(100% - 19%);
  width: calc(10% - 30px);
  min-width: 89.09px;
  text-align: center;
}

.col5 {
  position: absolute;
  left: calc(100% - 8.75%);
  width: calc(10% - 30px);
  min-width: 89.09px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.graphSection {
  position: fixed;
  top: 95px;
  border-top: 6px solid white;
  z-index: 2;
  background-color: white;
  width: 100%;
}

.headerDash {
  display: grid;
  grid-template-columns: 60% 10% 10% 10% 10%;
  background-color: rgba(0, 0, 0);
  color: white;
  height: 30px;
  width: 99%;
  /* min-width: 912px; */

}

.headerDash > div:first-child {
  text-align: center;
}

.headerDash > div{
  text-align: center;
}

.dashSectionWithModal {
  position: relative;
  top: 330px;
  width: 100%;
  margin-bottom: 1%;
  min-width: 912px;
  /* overflow-x: auto; */
}

.dashSectionWithoutModal {
  position: relative;
  top: 10px;
  width: 100%;
}

.root-header {
  display: none;
}

.headerDashPositionWithModal {
  position: fixed;
  top: 420px;
  z-index: 1;
  width: 99%;
  /* overflow-x: hidden; */
  /* min-width: 906px; */
}

.headerDashPositionWithoutModal {
  position: fixed;
  top: 95px;
  z-index: 1;
  width: 99%;
  border-top: 4px solid white;
  min-width: 840px;
}

.tree {
  min-width: 840px;
} 

/* #filter-tree {
  border: 2px solid black;
  border-radius: 4px;
} */

@media only screen and (max-width: 1855px){

  .col2 {
    left: calc(100% - 38.7%);

  }

  .col3 {
    left: calc(100% - 28.7%);

  }

  .col4 {
    left: calc(100% - 19%);
  }

  .col5 {
    left: calc(100% - 8.4%);
  }

}

@media only screen and (max-width: 1366px) {

  .col2 {
    left: calc(100% - 38.2%);

  }

  .col3 {
    left: calc(100% - 28.2%);

  }

  .col4 {
    left: calc(100% - 18.5%);
  }

  .col5 {
    left: calc(100% - 8%);

  }

  
}

@media only screen and (max-width: 1190px) {
  #hd {
    display: grid;
    border-top-right-radius:  8px;
    border-top-left-radius:  8px;
  } 

  .root-header {
    display: inline;
  }
/* .graphSection { */
  /* display: grid; */
  /* top: 85px; */
/* } */

.headerDash {
  height: 30px;
} 

}

@media only screen and (max-width: 1160px) {

  .graphSection {
    display: grid;
    top: 120px;
  }

  #filter-tree{
  margin-top: 0.7rem;
  margin-bottom: 0.2rem;
}

  .headerDashPositionWithoutModal,
 .headerDashPositionWithModal { 
  display: none;
} 

.col5 {
  left: calc(100% - 8%);
}

/* #hd {
    display: grid;
    top: 125px;
  } */
}

</style>